export const generatePositionProfileName = ({
  positionName,
  technology,
  competencyLevel,
}: {
  positionName: string;
  technology?: string | null;
  competencyLevel: string;
}) => [positionName, technology, competencyLevel].filter(Boolean).join(' ');
